import { AbstractCommand } from 'src/models/command';
import { StatusEnum } from 'src/models/status/enums';

class SetTheStateForMultipleAggregates extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Legacy_Modules_Status_SetTheStateForMultipleAggregates';

	public constructor(aggregateIds: string[], processId: string, state: StatusEnum) {
		super();
		this.processId = processId;
		this.parameters = {
			aggregateIds: aggregateIds,
			state: state,
		};
	}
}

export { SetTheStateForMultipleAggregates };
